import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M16 10a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8.912 3.919l4.915-6.008-1.006-.823-4.085 4.992-2.496-2.08-.832.999 3.504 2.92z",
      fill: "#23aa71"
    }, null, -1)
  ])))
}
export default { render: render }